module.exports = __webpack_public_path__ + "img/self1.c4e26c9e.jpg";